import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import selectn from "selectn";
var FALLBACK_ERROR_MESSAGE = "Ups, da stimmt was nicht. Bitte überprüfe Deine Angabe!";
var errorMessages = {
  format: {
    email: "Bitte trage eine korrekte E-Mail Adresse ein!",
    date: "Bitte trage ein korrektes Datum ein!",
    uri: "Bitte trage eine korrekte Web-Adresse ein!"
  },
  required: "Dieses Feld ist ein Pflichtfeld!",
  pattern: FALLBACK_ERROR_MESSAGE
};
var customErrorProps = {
  format: "ui:formatError",
  required: "ui:requiredError",
  pattern: "ui:patternError",
  notUnique: "ui:notUniqueError"
};
export default function transformErrors(errors, uiSchema) {
  return errors.map(function (error) {
    error = _objectSpread(_objectSpread({}, error), {}, {
      originalMessage: error.message
    });
    var customError = getCustomError(error.name, error.property, uiSchema);
    if (customError !== undefined) return _objectSpread(_objectSpread({}, error), {}, {
      message: customError
    });
    switch (error.name) {
      case "format":
        return _objectSpread(_objectSpread({}, error), {}, {
          message: errorMessages["format"][error.params.format] || FALLBACK_ERROR_MESSAGE
        });
    }
    return _objectSpread(_objectSpread({}, error), {}, {
      message: errorMessages[error.name] || FALLBACK_ERROR_MESSAGE
    });
  });
}
export function createTransformer(uiSchema) {
  return function (errors) {
    return transformErrors(errors, uiSchema);
  };
}

/*
 * Util
 */

function getCustomError(errorName, propName, uiSchema) {
  if (!customErrorProps.hasOwnProperty(errorName)) return;
  var schema = selectn(normName(propName), uiSchema);
  return schema && schema[customErrorProps[errorName]];
}
function normName(name) {
  if (name.charAt(0) === ".") {
    name = name.substr(1);
  }
  return name;
}
//# sourceMappingURL=transformErrors.js.map